import React, { useState, useEffect, useRef } from "react";
import "../style/MenuStock.css";
import CarRowOverview from "./CarRowOverview";
import api from "../utils/apiClient";
import { useLocation } from "react-router-dom";
import FilterBox from "./Filterbox.jsx";
import { Spin } from "antd"; // Importando el componente de loading de Ant Design

function MenuStock({ reload ,activeOption }) {

   // Estado inicial de los checkboxes
   const initialCheckboxes = {
    chocados: false,
    buenEstado: false,
    arreglado: false,
    bus: false,
    cabezal: false,
    camioncito: false,
    camion: false,
    pickup: false,
    camioneta: false,
    turismo: false,
    gasolina: false,
    diesel: false,
    automatica: false,
    manual: false,
    delantera: false,
    trasera: false,
    ruedas: false,
    Usa: false,
    Tegucigalpa: false,
    SanLorenzo: false,
    Transito: false,
    Puerto: false,
  };

  const [, setFilter] = useState(false);
  const [marcas, setmarcas] = useState([]); 
  const [fullmarca, setfullmarca] = useState([]);
  const [modelos, setmodelos] = useState([]); 

  const getMarcas = async () => {
    try {
      const res = await api.get("marcasymodelos/marca");
      const list = Array.isArray(res.data) ? res.data : [];
      const names = list.map((carro) => carro.Nombre);

      const initial = { ...initialCheckboxes };
      names.forEach((marca) => { initial[marca] = false; });

      setCheckboxes(initial);
      setmarcas(names);
      setfullmarca(list);
      setIsInitializing(false);
    } catch (error) {
      console.error("Error fetching marcas:", error);
      setIsInitializing(false);
    }
  };



  const getmodelos = async (marcaID) => {
    try {
      const data = { marca: marcaID };
      const res = await api.post("marcasymodelos/modelobymarca", data);
      const list = Array.isArray(res.data) ? res.data : [];
      const nombres = list.map((m) => m.Nombre);
      setmodelos(nombres);

      // Update checkboxes state to include the models
      setCheckboxes((prevCheckboxes) => {
        const newCheckboxes = { ...prevCheckboxes };
        nombres.forEach((modelo) => {
          if (!(modelo in newCheckboxes)) {
            newCheckboxes[modelo] = false;
          }
        });
        return newCheckboxes;
      });
    } catch (error) {
      console.error("Error fetching modelos by marca:", error);
    }
  };

  const [showFilters, setShowFilters] = useState(window.innerWidth > 1024);
  const [checkboxes, setCheckboxes] = useState({});

  const [sliderValue, setSliderValue] = useState(1.0);
  const [carprice, setcarprice] = useState(null);
  const [caryr, setcaryr] = useState(null);
  const [carmotor, setcarmotor] = useState(null);
  const [activeFilter, setActiveFilter] = useState(null); // Nuevo estado para el filtro activo

  const [isModelMenuVisible, setIsModelMenuVisible] = useState(false);

  const findObjectByKeyValue = (array, key, value) => {
    return array.find((obj) => obj[key] === value);
  };

  const [checkboxchange, setcheckboxchange] = useState(false);


  const handleCheckboxChange = (event) => {
    setisfiltered(true);
    setcheckboxchange(!checkboxchange)
    const { name, checked } = event.target;

    if (marcas.includes(name)) {
      // Es una marca
      setCheckboxes((prevCheckboxes) => ({
        ...prevCheckboxes,
        [name]: checked,
      }));

      if (checked) {
        setIsModelMenuVisible(true);
        const algo = findObjectByKeyValue(fullmarca, "Nombre", name);
        getmodelos(algo._id);

        // Reinicia los modelos cuando se selecciona una nueva marca
        setCheckboxes((prevCheckboxes) => {
          const newCheckboxes = { ...prevCheckboxes };
          modelos.forEach((modelo) => {
            newCheckboxes[modelo] = false;
          });
          return newCheckboxes;
        });
      } else {
        setIsModelMenuVisible(false);
        setmodelos([]);

        // Reinicia los modelos cuando se deselecciona la marca
        setCheckboxes((prevCheckboxes) => {
          const newCheckboxes = { ...prevCheckboxes };
          modelos.forEach((modelo) => {
            delete newCheckboxes[modelo];
          });
          return newCheckboxes;
        });
      }
    } else if (modelos.includes(name)) {
      // Es un modelo
      setCheckboxes((prevCheckboxes) => ({
        ...prevCheckboxes,
        [name]: checked,
      }));
    } else {
      // Es otro filtro
      setCheckboxes((prevCheckboxes) => ({
        ...prevCheckboxes,
        [name]: checked,
      }));
    }
  };

  // Función para resetear filtros
  const handleResetFilters = () => {
    setCheckboxes({ ...initialCheckboxes });
    setcarprice(null);
    setcarmotor(null);
    setcaryr(null);
    setIsModelMenuVisible(false);
    setmodelos([]);
  };

  const isAnyFilterActive = () => {
    const anyCheckboxChecked = Object.keys(checkboxes).some(
      (key) => checkboxes[key]
    );
    const anySliderValue = sliderValue !== 1.0 || carprice || caryr || carmotor;
    return anyCheckboxChecked || anySliderValue;
  };

  const getSelectedModels = () => {
    return modelos.filter((modelo) => checkboxes[modelo]);
  };

  const handleModeloChange = (event) => {
    const { value } = event.target;
    setCheckboxes((prevCheckboxes) => ({
      ...prevCheckboxes,
      modelo: value, // Guarda el modelo seleccionado
    }));
    setisfiltered(true);
  };

  const handleSliderChange1 = (event, newValue) => {
    setisfiltered(true);
    setSliderValue(newValue);
    setcaryr(newValue);
  };

  const handleSliderChange2 = (event, newValue) => {
    setisfiltered(true);
    setSliderValue(newValue);
    setcarprice(newValue);
  };

  const handleSliderChange3 = (event, newValue) => {
    setisfiltered(true);
    setSliderValue(newValue);
    setcarmotor(newValue);
  };

  const toggleFilter = (filterName) => {
    setActiveFilter(activeFilter === filterName ? null : filterName); // Activa o desactiva el filtro
  };

  const location = useLocation();

  const getSearchParams = () => {
    const searchParams = new URLSearchParams(location.search);
    const params = {};
    for (let [key, value] of searchParams) {
      if (key === "anio") {
        params[key] = parseInt(value, 10);
        if (isNaN(params[key])) {
          params[key] = null;
        }
      } else {
        params[key] = value;
      }
    }
    return params;
  };

  const searchParams = getSearchParams();

  const findFirstTrue = (checkboxes) => {
    for (const key in checkboxes) {
      if (checkboxes[key]) {
        return key;
      }
    }
    return null;
  };

  function removeNulls(obj) {
    Object.keys(obj).forEach((key) => {
      if (obj[key] && typeof obj[key] === "object") {
        removeNulls(obj[key]); // Recurse into nested objects
      } else if (obj[key] === null) {
        delete obj[key]; // Delete keys where the value is null
      }
    });
    return obj;
  }

  const [carros, setCarros] = useState([]);
  const [loading, setLoading] = useState(false);
  const [otherloading, setotherloading] = useState(false);
  const [, setError] = useState(null);
  const carboxRef = useRef(null);

  const [isfiltered, setisfiltered] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const offRef = useRef(0);
  const offFilterRef = useRef(0);
  const currentFilterRef = useRef(null);
  // Fetch generation: bumped by every list-REPLACING fetch. Appenders capture
  // it before their request and discard the response if it changed — an
  // in-flight "load more" from the previous filter can otherwise land after
  // the new first page and mix/duplicate results.
  const fetchGenRef = useRef(0);
  const PAGE = 30;

  const filterquery = () => {
    setFilter(true);

    const selectedModels = getSelectedModels();

    const brandCheckboxValues = {};
    marcas.forEach((marca) => {
      brandCheckboxValues[marca] = checkboxes[marca];
    });


    const query = {
      marca: findFirstTrue(brandCheckboxValues),
      modelo: selectedModels.length > 0 ? selectedModels : null,
      condicion: findFirstTrue({
        Chocado: checkboxes.chocados,
        "Buen Estado": checkboxes.buenEstado,
        Arreglado: checkboxes.arreglado,
      }),
      combustible: findFirstTrue({
        Gasolina: checkboxes.gasolina,
        Diesel: checkboxes.diesel,
      }),
      ubicacion: findFirstTrue({
        USA: checkboxes.Usa,
        Tegucigalpa: checkboxes.Tegucigalpa,
        "San Lorenzo": checkboxes.SanLorenzo,
        "Puerto Cortez": checkboxes.Puerto,
        Transito: checkboxes.Transito,
      }),
      transmission: findFirstTrue({
        "Automática": checkboxes.automatica,
        "Mecánica": checkboxes.manual,
      }),
      traccion: findFirstTrue({
        Delantera: checkboxes.delantera,
        Trasera: checkboxes.trasera,
        "4x4": checkboxes.ruedas,
      }),
      tipo: findFirstTrue({
        Sedan: checkboxes.turismo,
        Camioneta: checkboxes.camioneta,
        "Pick Up": checkboxes.pickup,
        "Camión": checkboxes.camion,
        Camioncito: checkboxes.camioncito,
        Cabezal: checkboxes.cabezal,
        Bus: checkboxes.bus,
      }),
      precio: carprice,
      motor: (carmotor * 1000).toString(),
      anio: caryr,
    };

    const cleanedQuery = removeNulls(query);

    const fetchCarrosFilter = async () => {
      fetchGenRef.current += 1;
      setisfiltered(true);
      currentFilterRef.current = { endpoint: "filter/", body: cleanedQuery };
      offFilterRef.current = 0;
      setHasMore(true);
      setLoading(true);
      setCarros([]);

      try {
        const filteredRes = await api.post(
          `filter/?offset=0&limit=${PAGE}`,
          cleanedQuery
        );
        const list = filteredRes.data.carros || [];
        setCarros(list);
        setHasMore(Boolean(filteredRes.data.hasMore));
        offFilterRef.current = list.length;
        setError(null);
      } catch (error) {
        console.error("Error fetching data:", error);
        setError("Failed to fetch data");
        setCarros([]);
      }
      setLoading(false);
    };
    fetchCarrosFilter();
  };

  const fetchItems = async () => {
    // `loading` = an initial fetch is replacing the list with offset-0 data.
    // A scroll event landing during it (e.g. the browser's scroll clamp when
    // navigating from a scrolled-down page) must not fire a second offset-0
    // request — it would append the same page and show every car twice.
    if (!hasMore || loading) {
      setotherloading(false);
      return;
    }
    const gen = fetchGenRef.current;
    try {
      const response = await api.get(
        `findspecial/paginated/${offRef.current}`
      );
      if (gen !== fetchGenRef.current) return; // a replacing fetch superseded us
      const list = response.data.carros || [];
      setCarros((prevItems) => [...prevItems, ...list]);
      setHasMore(Boolean(response.data.hasMore));
      offRef.current += list.length || PAGE;
    } catch (error) {
      setError("Failed to fetch data");
      console.error("Failed to fetch items", error);
    } finally {
      setotherloading(false);
    }
  };

  const fetchItemsInit = async () => {
    if (!hasMore || otherloading) {
      return;
    }
    fetchGenRef.current += 1;
    setLoading(true);
    try {
      const response = await api.get(
        `findspecial/paginated/${offRef.current}`
      );
      const list = response.data.carros || [];
      setCarros((prevItems) => [...prevItems, ...list]);
      setHasMore(Boolean(response.data.hasMore));
      offRef.current += list.length || PAGE;
    } catch (error) {
      setError("Failed to fetch data");
      console.error("Failed to fetch items", error);
    } finally {
      setLoading(false);
    }
  };

  // Back to the unfiltered listing after the URL's params were cleared
  // in-place (e.g. "Ver todos" while on /stock?marca=X — a client-side
  // navigation that never remounts this component).
  const resetToUnfiltered = async () => {
    fetchGenRef.current += 1;
    setisfiltered(false);
    currentFilterRef.current = null;
    offRef.current = 0;
    setHasMore(true);
    setLoading(true);
    setCarros([]);
    try {
      const response = await api.get("findspecial/paginated/0");
      const list = response.data.carros || [];
      setCarros(list);
      setHasMore(Boolean(response.data.hasMore));
      offRef.current = list.length;
      setError(null);
    } catch (error) {
      setError("Failed to fetch data");
      console.error("Failed to fetch items", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchFilteredItems = async () => {
    // Same guard as fetchItems: never overlap the initial filtered fetch, or
    // its offset-0 page gets appended twice (duplicated cars) and the offset
    // ref double-advances (skipped page).
    if (!hasMore || !currentFilterRef.current || loading) {
      setotherloading(false);
      return;
    }
    const gen = fetchGenRef.current;
    try {
      const { endpoint, body } = currentFilterRef.current;
      const res = await api.post(
        `${endpoint}?offset=${offFilterRef.current}&limit=${PAGE}`,
        body
      );
      if (gen !== fetchGenRef.current) return; // a replacing fetch superseded us
      const list = res.data.carros || [];
      setCarros((prev) => [...prev, ...list]);
      setHasMore(Boolean(res.data.hasMore));
      offFilterRef.current += list.length || PAGE;
    } catch (error) {
      setError("Failed to fetch data");
      console.error("Failed to fetch filtered items", error);
    } finally {
      setotherloading(false);
    }
  };

  const fetchCarrosType = async () => {
    if (loading || otherloading) {
      return;
    }
    fetchGenRef.current += 1;
    setLoading(true);
    setisfiltered(true);
    currentFilterRef.current = { endpoint: "filter/", body: searchParams };
    offFilterRef.current = 0;
    setHasMore(true);
    try {
      setCarros([]);
      const filteredResTIPO = await api.post(
        `filter/?offset=0&limit=${PAGE}`,
        searchParams
      );
      const list = filteredResTIPO.data.carros || [];
      setCarros(list);
      setHasMore(Boolean(filteredResTIPO.data.hasMore));
      offFilterRef.current = list.length;
      setError(null);
    } catch (error) {
      console.error("Error fetching data:", error);
      setError("Failed to fetch data");
      setCarros([]);
    } finally {
      setLoading(false);
    }
  };

  const hasSearchParams = Object.keys(searchParams).length > 0;

  const hasMounted = useRef(false);

  const [isInitializing, setIsInitializing] = useState(true);  

  useEffect(() => {
    getMarcas();  // Fetch brand names on mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);  // Empty dependency array ensures it runs only once
  
  useEffect(() => {
    if (hasSearchParams) {
      fetchCarrosType();
    } else if (!hasMounted.current) {
      fetchItemsInit();
    } else {
      // Params were cleared while already mounted ("Ver todos" / an empty
      // search from a filtered view) — without this the URL changed but the
      // filtered list silently stayed.
      resetToUnfiltered();
    }
    hasMounted.current = true;
    // location.search is a dep so in-place URL changes (client-side Links to
    // /stock?... while already on /stock) refetch — reload alone only covers
    // SearchBar commits.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reload, location.search]);

  const handleScroll = () => {
    const carbox = carboxRef.current;
    if (!carbox) return;

    const threshold = 150;
    // On mobile the carbox has no max-height (the page scrolls instead of the
    // box), so element scroll metrics never move — measure against the
    // viewport in that case.
    const scrollsInternally = carbox.scrollHeight > carbox.clientHeight + 1;
    const nearBottom = scrollsInternally
      ? carbox.scrollTop + carbox.clientHeight >= carbox.scrollHeight - threshold
      : carbox.getBoundingClientRect().bottom - window.innerHeight <= threshold;

    if (nearBottom && hasMore) {
      setotherloading(true);
    }
  };

  useEffect(() => {
    if (otherloading) {
      if (isfiltered) {
        fetchFilteredItems();
      } else {
        fetchItems();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [otherloading, isfiltered]);

  useEffect(() => {
    const carbox = carboxRef.current;
    if (carbox) {
      carbox.addEventListener("scroll", handleScroll);
    }
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => {
      if (carbox) {
        carbox.removeEventListener("scroll", handleScroll);
      }
      window.removeEventListener("scroll", handleScroll);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasMore]);

  useEffect(() => {
    if (isfiltered && !isInitializing) {
      filterquery();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [checkboxchange,sliderValue]);

  const toggleFilters = () => {
    setShowFilters(!showFilters);
  };

  return (
    <>
      <div className="stock-container">
        <div className="column-s">
          <button className="btn-toggle-filters" onClick={toggleFilters}>
            {showFilters ? "Ocultar filtros" : "Mostrar filtros"}
          </button>
          <FilterBox
            toggleFilter={toggleFilter}
            activeOption={activeOption}
            checkboxes={checkboxes}
            handleCheckboxChange={handleCheckboxChange}
            handleModeloChange={handleModeloChange}
            sliderValue={sliderValue}
            handleSliderChange1={handleSliderChange1}
            handleSliderChange2={handleSliderChange2}
            handleSliderChange3={handleSliderChange3}
            isVisible={showFilters}
            filterquery={filterquery}
            activeFilter={activeFilter} // Pasa el filtro activo
            isModelMenuVisible={isModelMenuVisible}
            marcas={marcas}
            modelos={modelos}
            handleResetFilters={handleResetFilters}
            isAnyFilterActive={isAnyFilterActive}
          />
        </div>
        <div className="carbox carbox-rows" ref={carboxRef}>
          {loading ? (
            <div className="loading-overlay-stock">
              <Spin size="large" />
            </div>
          ) : carros.length > 0 ? (
            carros.map((carro) => <CarRowOverview key={carro._id} carro={carro} />)
          ) : (
            <div className="no-cars-message">
              No hay vehículos disponibles con los filtros seleccionados.
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export default MenuStock;
